var render = function render(){var _vm=this,_c=_vm._self._c;return _c('error-output',{staticClass:"gpoint",style:(_vm.wrapperStyle),attrs:{"errors":_vm.errors}},[_c('a-input',{ref:"focusOnMount",staticClass:"gpoint__input",attrs:{"value":_vm.input,"size":_vm.size},on:{"input":_vm.inputChanged}}),_c('div',{ref:"map",style:(_vm.containerStyle)})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }